import { render, staticRenderFns } from "./veryhappy.vue?vue&type=template&id=53b3708a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53b3708a')) {
      api.createRecord('53b3708a', component.options)
    } else {
      api.reload('53b3708a', component.options)
    }
    module.hot.accept("./veryhappy.vue?vue&type=template&id=53b3708a&", function () {
      api.rerender('53b3708a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/smileys/veryhappy.vue"
export default component.exports